// OneDrive:CoverageThreshold(0)

export * from '@ms/telemetry-manager/lib/SingleEventBase';
